export default "/_next/static/chunks/fonts/HK Grotesk-fead2af1f7c554c13e603a14d8915fc4.otf";